import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Daughters Enterprise. All rights reserved.</p>
      <p>Contact us: daughtersenterprise29@gmail.com</p>
    </footer>
  );
}

export default Footer;